var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("span", {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.$t("应用语言")) + ":")]), _c("a-tabs", {
    class: {
      padd1: _vm.$t("应用语言").length < 17 && _vm.$t("应用语言").length > 15,
      padd2: _vm.$t("应用语言").length > 17
    },
    attrs: {
      type: "card",
      activeKey: _vm.locale
    },
    on: {
      change: _vm.languageChange
    }
  }, _vm._l(_vm.tabs, function (item) {
    return _c("a-tab-pane", {
      key: item.key,
      attrs: {
        tab: _vm.$t(item.tab)
      }
    }, [_c("div", {
      staticClass: "handle"
    }, [_c("a-button", {
      attrs: {
        type: "primary"
      },
      on: {
        click: function ($event) {
          return _vm.handleCli("add");
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("新增")))])], 1), _c("a-table", {
      attrs: {
        columns: _vm.columns,
        "data-source": _vm.data,
        bordered: "",
        pagination: _vm.pagination,
        rowKey: "id"
      },
      on: {
        change: _vm.handleTableChange
      },
      scopedSlots: _vm._u([{
        key: "index",
        fn: function (text, record, index) {
          return [_vm._v(" " + _vm._s(index + 1) + " ")];
        }
      }, {
        key: "operation",
        fn: function (text, record) {
          return [_c("a-button", {
            attrs: {
              type: "primary"
            },
            on: {
              click: function ($event) {
                return _vm.handleCli("preview", record);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t("预览")))]), _c("a-button", {
            staticStyle: {
              "margin-left": "10px"
            },
            attrs: {
              type: "edit"
            },
            on: {
              click: function ($event) {
                return _vm.handleCli("edit", record);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t("编辑")))])];
        }
      }], null, true)
    }, _vm._l(_vm.columns, function (item, i) {
      var _item$slots, _item$slots2, _item$slots3;
      return _c("span", {
        key: i,
        attrs: {
          slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
        },
        slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
      }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
    }), 0)], 1);
  }), 1), _vm.modalVisible ? _c("addClauseModal", {
    attrs: {
      modalVisible: _vm.modalVisible,
      language: _vm.language,
      itemData: _vm.itemData
    },
    on: {
      "update:modalVisible": function ($event) {
        _vm.modalVisible = $event;
      },
      "update:modal-visible": function ($event) {
        _vm.modalVisible = $event;
      },
      saveSuccess: _vm.getSystemConfigFileList
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };